import { defineStore } from "pinia";
import Services from '@/services/socialMediaServices'
import { mapSocialMedia } from '@/helpers/mapFuncs'

export const useSocialMediaStore = defineStore("socialMedia", {

state:()=>({
    socialMedia: {},
    socialMedias: [],
}),
getters : {
    getSocialMedia() {
        return mapSocialMedia(this.socialMedia)
    },
    getSocialMedias() {
        return this.socialMedias.map(mapSocialMedia)
    }
},
actions : {
    /** Start Sets */
    setSocialMedia(socialMedia) {
        this.socialMedia = socialMedia
    },
    setSocialMedias(socialMedias) {
        this.socialMedias = socialMedias
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setSocialMedia(response.data.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setSocialMedia(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setSocialMedias(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.socialMedias.push(response.data.data)
            return mapSocialMedia(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.socialMedias[this.socialMedias.findIndex((x)=>x.id == id)] = response.data.data
            return mapSocialMedia(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.socialMedias = this.socialMedias.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});